import { useEffect } from "react"
import addCSSClass from "src/libs/layout-app/utils/addCSSClass"
import removeCSSClass from "src/libs/layout-app/utils/removeCSSClass"
import { ICardFieldProps } from "../cards/CardField"
import { IconPrimitive } from "../../primitive"
import { defaultPrimitive } from "src/modules/pe-landing-module/data/interfaces"

/* Protopia Ecosystem component */
const CardFieldIcon = (props: ICardFieldProps): JSX.Element => {
    const { value, field, section, i } = props

    useEffect(() => { 
        addCSSClass(
            `landing-card-field-icon-${section.id + "-" + value?.id}`,
            `.landing-card-field-icon-${section.id + "-" + value?.id} {
                
            } 
            `
        )
        return () => removeCSSClass(`landing-card-field-icon-${section.id + "-" + value?.id}`)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []) 

    const primitive = {
        ...defaultPrimitive(),
        ...field,
        ...value,
        data: {
            ...field.data,
            src: value.data || field.src,
        },
        style: { 
            width:  value.style?.width || field.width || 75,
            height: value.style?.height || field.height || 75,        
        },
        className: (field.className || "") + " " + (value.style || "") + " medallion-padder",
        width:  field.width  || 75,
        height: field.height || 75,     
        id: section.id + "-" + value?.id, 
    }
    return <div 
        className={`landing-card-field landing-card-field-icon ${value.className || ""}`} 
        style={{ ...field.style, ...value.style }} 
        data-card-field-id={i}
        card-field-section-id={section.id}
    > 
        <IconPrimitive primitive={ primitive } /> 
    </div>
}
export default CardFieldIcon